import React from 'react'
import { bool, string, shape } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import CardDescription from './PlanCardDescription.style'

export default function PlanCardDescription({ plan, theme }) {
  return (
    <CardDescription color={theme.description.color}>
      {plan.isTheMostBasicPlan && (
        <FormattedMessage id="smb_acquisition_gym_search_map.plans.first_plan" />
      )}
      {!plan.isTheMostBasicPlan && (
        <FormattedMessage
          id="smb_acquisition_gym_search_map.plans.also_include"
          values={{
            selected_plan: plan.title,
            previous_plan: plan.previousPlan,
          }}
        />
      )}
      <FormattedMessage id="smb_acquisition_gym_search_map.payment_instruction" />
    </CardDescription>
  )
}

PlanCardDescription.propTypes = {
  plan: shape({
    title: string,
    previousPlan: string,
    isTheMostBasicPlan: bool,
  }).isRequired,
  theme: shape({
    description: shape({
      color: string,
    }),
  }),
}

PlanCardDescription.defaultProps = {
  theme: {
    description: {
      color: '',
    },
  },
}
